(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dominus-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  // $(document).ready(function () {
  //   $(".accordion details").on("click", function () {
  //     $(this).attr("open");
  //     $(this).parent(".accordion").siblings().find("details").removeAttr("open");
  //   });
  // });

  if (document.querySelector('.accordion details')) {
  // Fetch all the details elements
  const details = document.querySelectorAll('.accordion details');

  // Add onclick listeners
  details.forEach((targetDetail) => {
    targetDetail.addEventListener("click", () => {
      // Close all details that are not targetDetail
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.removeAttribute("open");
        }
      });
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-testimonial-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.our_testimonial_inner', {
      slidesPerView: 1.1,
      spaceBetween: 40,
      loop: true,
      centeredSlides: false,
      navigation: false,
      pagination: {
        el: '.swiper-pagination_stay',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
         centeredSlides: false,
          spaceBetween: 10, 
        },
        768: {
          slidesPerView: 2,
         centeredSlides: false,
          spaceBetween: 15, 
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20, 
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 40, 
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq"] && !Shopify.designMode) return;
  try {
    
    const firstFaqItem = document.querySelector('.faq_items:first-child');
    if (firstFaqItem) {
    const title = firstFaqItem.querySelector('.faq_title');
    const answer = firstFaqItem.querySelector('.faq_ans');
    if (firstFaqItem) {
        firstFaqItem.classList.add('active');
    }
    if (answer) {
        answer.style.display = 'block'; 
    }
    }

  $('.faq_items .faq_title').click(function(){
    $(this).parent().siblings().removeClass('active');
    $(this).parent().siblings().find('.faq_ans').slideUp();
    $(this).next().slideToggle();
    $(this).parent().toggleClass('active');
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-got-question"] && !Shopify.designMode) return;
  try {
    
    const firstFaqItem = document.querySelector('.faq_items:first-child');
    if (firstFaqItem) {
    const title = firstFaqItem.querySelector('.faq_title');
    const answer = firstFaqItem.querySelector('.faq_ans');
    if (firstFaqItem) {
        firstFaqItem.classList.add('active');
    }
    if (answer) {
        answer.style.display = 'block'; 
    }
    }

  $('.faq_items .faq_title').click(function(){
    $(this).parent().siblings().removeClass('active');
    $(this).parent().siblings().find('.faq_ans').slideUp();
    $(this).next().slideToggle();
    $(this).parent().toggleClass('active');
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-size-guide-tabs"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
    $('.size_guide_tabs li:first-child').addClass('active');
  $('.size_guide_tabs a').on('click', function (e) {
    e.preventDefault(); 
    $('.size_guide_tabs li').removeClass('active');
    $(this).parent().addClass('active');
    var target = this.hash,
        $target = $(target);

    if ($target.length) {
      $('html, body').stop().animate({
        scrollTop: $target.offset().top - 100
      }, 900, 'swing', function () {
        window.location.hash = target;
      });
    }
  });
  
});


$(window).on('scroll', function () {
  var scrollDistance = $(window).scrollTop();

  $('.size_guide_care_main__sec').each(function (i) {
    if ($(this).position().top - 100 <= scrollDistance) {
      $('.size_guide_tabs li').removeClass('active');
      $('.size_guide_tabs li').eq(i).addClass('active');
    }
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.story_inner', {
      slidesPerView: 1.1,
      spaceBetween: 40,
      loop: true,
      centeredSlides: false,
      navigation: {
        nextEl: '.swiper-button-next_story',
        prevEl: '.swiper-button-prev_story',
      },
      pagination: {
        el: '.swiper-pagination_story',
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
         centeredSlides: false,
         spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
         centeredSlides: false,
         spaceBetween: 15,
        },
        992: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 2.5,
          spaceBetween: 40,
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.testimonial-swiper', {
      slidesPerView: 1.1,
      spaceBetween: 20,
      loop: true,
      centeredSlides: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
         centeredSlides: false,
        },
        1024: {
          slidesPerView: 3,
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
